import { useTranslation } from 'react-i18next';
import { Link, Stack, Typography } from '@mui/material';

interface IDTicketLinkHelpSectionProps {
	onClick: () => void;
}

export const DTicketLinkHelpSection = ({
	onClick,
}: IDTicketLinkHelpSectionProps) => {
	const { t } = useTranslation('userDTicket');

	return (
		<Stack alignItems="center">
			<Typography variant="l1" color="primary.main">
				<Link
					component="button"
					underline="always"
					onClick={onClick}
					sx={{ cursor: 'pointer' }}
					data-testid="dticket-linkHelpSection-help-link"
				>
					{t('help_section.text')}
				</Link>
			</Typography>
		</Stack>
	);
};
